export class DocumentRequirementModel {
    public requirementViewId?: string;
    public id: number;
    public documentTypeId: number;
    public documentType: string;
    public documentCategoryTypeId: number;
    public documentCategoryType: string;
    public documentRequirementTypeId: number;
    public documentId: number;
    public documentTypes?: any[] = [];
    public documentAccessControlTypeId: number;
    public scanLater?: boolean;
    public updatedBy?: string;
    public updatedDate?: string;
    public validationResults?: any;
    public isValid?: boolean;
    public isClean?: boolean;
}
